import { render, staticRenderFns } from "./AutorizarForm.vue?vue&type=template&id=1f0bb968&"
import script from "./AutorizarForm.vue?vue&type=script&lang=js&"
export * from "./AutorizarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports